<template>
  <Layout />
</template>

<script>
import Layout from './views/portfolio/Layout.vue';

export default {
  name: 'App',
  components: {
    Layout
  }
}
</script>
